import React, { useEffect, useRef } from "react";
import PersonalDetails from "../../../components/PersonalDetails";
import EmailAddress from "../../../components/EmailAddress";
import ProfilePhoneNumber from "../../../components/ProfilePhoneNumber";
import MailingAddress from "../../../components/MailingAddress";
import { useUserProfile } from "../../../hooks/getUserProfile";
import LocationAndRoles from "../../../components/LocationAndRoles";

const ProfilePersonalDetails = () => {
  const { data: userProfile, isLoading, refetch } = useUserProfile();
  const scrollRef = useRef(null);
  const contentRef = useRef(null);
  const thumbRef = useRef(null);

  useEffect(() => {
    const scrollEl = scrollRef.current;
    const contentEl = contentRef.current;
    const thumbEl = thumbRef.current;

    if (!scrollEl || !contentEl || !thumbEl) {
      return undefined;
    }

    const updateThumb = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollEl;
      const trackHeight = clientHeight;

      if (scrollHeight <= 0 || trackHeight <= 0) {
        return;
      }

      const ratio = Math.min(clientHeight / scrollHeight, 1);
      const minThumbHeight = 24;
      const thumbHeight = Math.max(trackHeight * ratio, minThumbHeight);
      const maxTop = trackHeight - thumbHeight;
      const top =
        scrollHeight <= clientHeight
          ? 0
          : (scrollTop / (scrollHeight - clientHeight)) * maxTop;

      thumbEl.style.height = `${thumbHeight}px`;
      thumbEl.style.transform = `translateY(${top}px)`;
      thumbEl.style.opacity = scrollHeight <= clientHeight ? "0.35" : "1";
    };

    let frame = 0;
    const scheduleUpdate = () => {
      if (frame) {
        return;
      }
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        updateThumb();
      });
    };

    updateThumb();
    scrollEl.addEventListener("scroll", scheduleUpdate);

    const resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(scrollEl);
    resizeObserver.observe(contentEl);

    window.addEventListener("resize", scheduleUpdate);

    return () => {
      scrollEl.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
      resizeObserver.disconnect();
      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  return (
    <div className="h-90 scrollRightEdge customScrollContainer">
      <div className="customScrollViewport pb-17" ref={scrollRef}>
        <div className="customScrollContent" ref={contentRef}>
          <LocationAndRoles
            userProfile={userProfile?.data}
            isLoading={isLoading}
            refetch={refetch}
          />
          <PersonalDetails
            userProfile={userProfile?.data}
            isLoading={isLoading}
            refetch={refetch}
          />
          <EmailAddress
            userProfile={userProfile?.data}
            isLoading={isLoading}
            refetch={refetch}
          />
          <ProfilePhoneNumber
            userProfile={userProfile?.data}
            isLoading={isLoading}
            refetch={refetch}
          />
          <MailingAddress
            userProfile={userProfile?.data}
            isLoading={isLoading}
            refetch={refetch}
          />
        </div>
      </div>
      <div className="customScrollBar" aria-hidden="true">
        <div className="customScrollThumb" ref={thumbRef} />
      </div>
    </div>
  );
};

export default ProfilePersonalDetails;
